import React, {lazy, Suspense} from 'react';
import Provider from './Provider';

const Toasts = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./Toasts'));

const Wrapper = ({children}) => {

    return <Provider>
        {children}
        <Suspense>
            <Toasts />
        </Suspense>
    </Provider>
}

export default Wrapper;
